function isPlaylistValid(playlist) {
  return Boolean(playlist && playlist.length);
}

export default isPlaylistValid;
